export type PolicyBuilding={id:string;name:string;code?:string|null};
export function insuranceBuildingLabel(buildings:PolicyBuilding[]|undefined){
 return buildings?.length?buildings.map(building=>building.code?.trim()||building.name).join(', '):'Not recorded';
}
export function insuranceTypeLabel(types:string[]|undefined){
 const names=[...new Set(types??[])];
 if(names.includes('Buildings / property owners'))return 'Buildings';
 const labels:Record<string,string>={'Directors and officers':'D&O','Employers liability':'Employers’ liability','Engineering damage':'Engineering damage','Engineering inspection':'Engineering inspection','Fidelity / crime':'Fidelity / crime','Unknown':'Not recorded'};
 return names.length?names.map(name=>labels[name]??name).join(' / '):'Not recorded';
}
export function insuranceInsurerLabel(name:string|null|undefined){
 if(!name?.trim())return 'Not recorded';
 const value=name.trim();
 if(/^axa(?:\s|$)/i.test(value))return 'AXA';
 if(/^allianz(?:\s|$)/i.test(value))return 'Allianz';
 return value;
}
export function insuranceExpiryLabel(value:string|null|undefined){
 const date=/^(\d{4})-(\d{2})-(\d{2})$/.exec(value??'');
 return date?`${Number(date[3])}/${Number(date[2])}/${date[1]}`:'Not recorded';
}
